var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal-target',{staticClass:"fixed inset-0 flex flex-col items-center justify-end px-4 py-6 pointer-events-none z-40 space-y-4 | md:p-6",attrs:{"multiple":"","name":"screen-pop"}})
}
var staticRenderFns = []

export { render, staticRenderFns }